export const waQuotesData = [
  {
    "name": "Armadale",
    "value": 1,
    "lat": -32.152266,
    "lng": 116.0147457
  },
  {
    "name": "Ballaying",
    "value": 1,
    "lat": -33.3075,
    "lng": 117.5592
  },
  {
    "name": "Bidyadanga",
    "value": 2,
    "lat": -18.6844918,
    "lng": 121.7780138
  },
  {
    "name": "Boddington",
    "value": 4,
    "lat": -32.8023099,
    "lng": 116.475076
  },
  {
    "name": "Broome",
    "value": 1,
    "lat": -17.9566909,
    "lng": 122.2240181
  },
  {
    "name": "Brown Hill",
    "value": 1,
    "lat": -30.758692500000002,
    "lng": 121.52649151091782
  },
  {
    "name": "Bullsbrook",
    "value": 1,
    "lat": -31.660562849999998,
    "lng": 116.03357969757423
  },
  {
    "name": "Bunbury",
    "value": 7,
    "lat": -33.3267797,
    "lng": 115.636698
  },
  {
    "name": "Collie",
    "value": 2,
    "lat": -33.3591223,
    "lng": 116.1536169
  },
  {
    "name": "Coogee",
    "value": 1,
    "lat": -32.121836,
    "lng": 115.7684345
  },
  {
    "name": "Dalyellup",
    "value": 2,
    "lat": -33.410681,
    "lng": 115.61313525149313
  },
  {
    "name": "Eagle Bay",
    "value": 1,
    "lat": -33.56075,
    "lng": 115.0632
  },
  {
    "name": "Eaton",
    "value": 1,
    "lat": -33.3086615,
    "lng": 115.72464546962061
  },
  {
    "name": "Edgewater",
    "value": 3,
    "lat": -31.76322,
    "lng": 115.7818
  },
  {
    "name": "Esperance",
    "value": 5,
    "lat": -33.858228,
    "lng": 121.8931606
  },
  {
    "name": "Forrestdale",
    "value": 12,
    "lat": -32.1504796,
    "lng": 115.9378093
  },
  {
    "name": "Fremantle",
    "value": 1,
    "lat": -32.0534086,
    "lng": 115.7586172
  },
  {
    "name": "Geraldton",
    "value": 1,
    "lat": -28.77035,
    "lng": 114.6147159
  },
  {
    "name": "Gerladton",
    "value": 1,
    "lat": -25.2303005,
    "lng": 121.0187246
  },
  {
    "name": "Henley Brook",
    "value": 1,
    "lat": -31.8067345,
    "lng": 115.9839963
  },
  {
    "name": "High Wycombe",
    "value": 2,
    "lat": -31.954628,
    "lng": 115.9921995
  },
  {
    "name": "Hilbert",
    "value": 1,
    "lat": -32.1719378,
    "lng": 115.9784985
  },
  {
    "name": "Kalgoorlie",
    "value": 4,
    "lat": -30.7464139,
    "lng": 121.473223
  },
  {
    "name": "Karratha",
    "value": 7,
    "lat": -20.7370067,
    "lng": 116.8478592
  },
  {
    "name": "Katanning",
    "value": 1,
    "lat": -33.6908682,
    "lng": 117.5551858
  },
  {
    "name": "Kulja",
    "value": 1,
    "lat": -30.4793519,
    "lng": 117.2873747
  },
  {
    "name": "Kwinana Beach",
    "value": 1,
    "lat": -32.2266186,
    "lng": 115.7763707
  },
  {
    "name": "Learmonth",
    "value": 3,
    "lat": -22.2409283,
    "lng": 114.0953233826033
  },
  {
    "name": "Neerabup",
    "value": 1,
    "lat": -31.70798295,
    "lng": 115.75191835167551
  },
  {
    "name": "Newman",
    "value": 9,
    "lat": -23.4178009,
    "lng": 119.8030015
  },
  {
    "name": "North Fremantle",
    "value": 1,
    "lat": -32.0327438,
    "lng": 115.7549789
  },
  {
    "name": "Onslow",
    "value": 1,
    "lat": -21.6382467,
    "lng": 115.1134438
  },
  {
    "name": "Palmer",
    "value": 1,
    "lat": -33.2914655,
    "lng": 116.2444232602436
  },
  {
    "name": "Perth",
    "value": 3,
    "lat": -31.9558967,
    "lng": 115.8605784
  },
  {
    "name": "Picton",
    "value": 1,
    "lat": -33.3415555,
    "lng": 115.70273985671639
  },
  {
    "name": "Pintharuka",
    "value": 1,
    "lat": -29.0751605,
    "lng": 116.1552802
  },
  {
    "name": "Rocklea",
    "value": 1,
    "lat": -22.9301215,
    "lng": 117.55251645173266
  },
  {
    "name": "Rottnest Island",
    "value": 1,
    "lat": -32.007009499999995,
    "lng": 115.52052709064799
  },
  {
    "name": "Sir Samuel",
    "value": 2,
    "lat": -27.538656,
    "lng": 120.4808899
  },
  {
    "name": "Southern Cross",
    "value": 3,
    "lat": -31.2282721,
    "lng": 119.327784
  },
  {
    "name": "TBC",
    "value": 7,
    "lat": -25.2303005,
    "lng": 121.0187246
  },
  {
    "name": "Telfa",
    "value": 1,
    "lat": -25.2303005,
    "lng": 121.0187246
  },
  {
    "name": "Test suburb",
    "value": 1,
    "lat": -33.347121,
    "lng": 115.6679457
  },
  {
    "name": "Tom Price",
    "value": 1,
    "lat": -22.6892972,
    "lng": 117.7974898
  },
  {
    "name": "WA",
    "value": 1,
    "lat": -31.950652,
    "lng": 115.7978755
  },
  {
    "name": "Wellesley",
    "value": 1,
    "lat": -33.194019,
    "lng": 115.76533597143828
  },
  {
    "name": "West Kalgoorlie",
    "value": 1,
    "lat": -30.77958,
    "lng": 121.4341604
  },
  {
    "name": "West Swan",
    "value": 2,
    "lat": -31.9319845,
    "lng": 115.9190544
  }
];
